// extracted by mini-css-extract-plugin
export var link = "downloadButton-module--link--UTqFS";
export var text = "downloadButton-module--text--4Fbyl";